import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import ErrorDetailsToggle from './errorDetailsToggle';
const GeneralNotification = _ref => {
  let _ref$headerMessage = _ref.headerMessage,
    headerMessage = _ref$headerMessage === void 0 ? '' : _ref$headerMessage,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message,
    _ref$hint = _ref.hint,
    hint = _ref$hint === void 0 ? '' : _ref$hint,
    _ref$technicalDetail = _ref.technicalDetail,
    technicalDetail = _ref$technicalDetail === void 0 ? '' : _ref$technicalDetail,
    _ref$reference = _ref.reference,
    reference = _ref$reference === void 0 ? '' : _ref$reference,
    _ref$errorCode = _ref.errorCode,
    errorCode = _ref$errorCode === void 0 ? '' : _ref$errorCode,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    _ref$leftButtonLabel = _ref.leftButtonLabel,
    leftButtonLabel = _ref$leftButtonLabel === void 0 ? '' : _ref$leftButtonLabel,
    _ref$leftButtonAction = _ref.leftButtonAction,
    leftButtonAction = _ref$leftButtonAction === void 0 ? () => {} : _ref$leftButtonAction,
    _ref$middleButtonLabe = _ref.middleButtonLabel,
    middleButtonLabel = _ref$middleButtonLabe === void 0 ? '' : _ref$middleButtonLabe,
    _ref$middleButtonActi = _ref.middleButtonAction,
    middleButtonAction = _ref$middleButtonActi === void 0 ? () => {} : _ref$middleButtonActi,
    _ref$rightButtonLabel = _ref.rightButtonLabel,
    rightButtonLabel = _ref$rightButtonLabel === void 0 ? '' : _ref$rightButtonLabel,
    _ref$rightButtonActio = _ref.rightButtonAction,
    rightButtonAction = _ref$rightButtonActio === void 0 ? () => {} : _ref$rightButtonActio,
    messageType = _ref.messageType;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('t-notification-general', 't-error-details-host')
  }, headerMessage.length ? /*#__PURE__*/React.createElement("span", {
    className: classnames("tqc-notification-".concat(messageType, "-header"), 't-notification-header')
  }, headerMessage) : '', headerMessage.length && (list.length || message.length) ? /*#__PURE__*/React.createElement("br", null) : '', list.length ? /*#__PURE__*/React.createElement("ul", {
    className: "t-notification-list"
  }, list.map(i => /*#__PURE__*/React.createElement("li", {
    key: Math.random()
  }, i))) : '', message.length ? message : '', /*#__PURE__*/React.createElement(ErrorDetailsToggle, {
    hint: hint,
    technicalDetail: technicalDetail,
    reference: reference,
    errorCode: errorCode
  }), leftButtonLabel.length || middleButtonLabel.length || rightButtonLabel.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)) : '', leftButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => leftButtonAction(),
    className: classnames('t-notification-button-left', "t-nbl-label-".concat(kebabCase(leftButtonLabel)))
  }, leftButtonLabel) : '', middleButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    style: {
      marginLeft: '10px'
    },
    onClick: () => middleButtonAction(),
    className: classnames('t-notification-button-middle', "t-nbm-label-".concat(kebabCase(middleButtonLabel)))
  }, middleButtonLabel) : '', rightButtonLabel.length ? /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    style: {
      float: 'right'
    },
    onClick: () => rightButtonAction(),
    className: classnames('t-notification-button-right', "t-nbr-label-".concat(kebabCase(rightButtonLabel)))
  }, rightButtonLabel) : '');
};
GeneralNotification.propTypes = {
  headerMessage: PropTypes.string,
  messageType: PropTypes.string.isRequired,
  message: PropTypes.string,
  hint: PropTypes.string,
  technicalDetail: PropTypes.string,
  reference: PropTypes.string,
  errorCode: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  leftButtonAction: PropTypes.func,
  leftButtonLabel: PropTypes.string,
  middleButtonAction: PropTypes.func,
  middleButtonLabel: PropTypes.string,
  rightButtonAction: PropTypes.func,
  rightButtonLabel: PropTypes.string
};
export default GeneralNotification;